<template>
  <b-modal
    id="add-user-modal"
    :visible="show"
    class="pt-2"
    size="md"
    :title="title"
    ok-only
    no-close-on-backdrop
    :ok-title="$t('Accept')"
    :cancel-title="$t('Cancel')"
    @close="$emit('close')"
    @hide="$emit('close')"
  >
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent>
        <validation-provider
          #default="{ errors }"
          name="user"
          rules="required"
        >
          <b-form-group
            :label="$t('Users')"
            class="text-bold"
          >
            <v-select
              v-model="form.selected_users"
              multiple
              :options="users"
              :reduce="item => item.uuid"
              :placeholder="$t('Select Users')"
              label="name"
            >
              <template #option="option">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :src="getAvatar(option.avatar)"
                    size="24"
                    badge
                    :badge-variant="option.isOnline ? 'success' : 'secondary'"
                    :text="getInitials(option.name)"
                    class="mr-1"
                    variant="light-primary"
                  />
                  <span>{{ option.name }}</span>
                </div>
              </template>
            </v-select>
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form>
    </validation-observer>
    <template #modal-footer>
      <b-row>
        <b-col
          md="12"
          class="d-flex justify-content-end"
        >
          <b-button
            variant="primary"
            :disabled="isProcessing"
            @click="handleOk"
          >
            <b-spinner
              v-show="isProcessing"
              small
            />
            <span v-if="form.id">
              {{ $t('Update') }}
            </span>
            <span v-else>
              {{ $t('Save') }}
            </span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import {
  BFormGroup, BForm, BButton, BSpinner, BAvatar,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import useApollo from '@/plugins/graphql/useApollo'
import { required } from '@validations'
import vSelect from 'vue-select'

const initialForm = () => ({
  id: null,
  selected_users: [],
})

export default {
  components: {
    BFormGroup,
    BAvatar,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BButton,
    BSpinner,
    vSelect,
  },
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    teamInfo: {
      type: Object,
      required: true,
    },
    members: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      title: this.$t('Add Member'),
      isProcessing: false,
      form: {
        ...initialForm(),
      },
      users: [],
      loadedProjectUuid: null,
      required,
    }
  },
  computed: {
    projectUuid() {
      return this.teamInfo?.project?.uuid || this.$store?.state?.project?.selectedProject
    },
  },
  watch: {
    members: {
      immediate: true,
      handler(newMembers) {
        this.form.selected_users = (Array.isArray(newMembers) ? newMembers : [])
          .map(m => (m && (m.uuid || m.uid)) || null)
          .filter(Boolean)
      },
    },
    projectUuid: {
      immediate: true,
      handler(projectUuid) {
        if (!projectUuid || this.loadedProjectUuid === projectUuid) return
        this.loadedProjectUuid = projectUuid

        useApollo.project.getAllProjectUser({
          uuid: projectUuid,
          first: -1,
        }).then(response => {
          this.users = response.data.project.users.data
        })
      },
    },
  },
  methods: {
    handleOk() {
      this.isProcessing = true
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const teamUid = this.teamInfo?.uuid
          const projectUid = this.projectUuid

          if (!teamUid || !projectUid) {
            this.showErrorMessage({ data: { message: 'Missing team/project context. Please refresh the page and try again.' } })
            this.isProcessing = false
            return
          }

          useApollo.team.addTeamMembers({
            userUids: this.form.selected_users.filter(user => !!user),
            teamUid,
            projectUid,
          }).then(response => {
            this.showSuccess(response.data.assignUsersToTeam.message)
            this.$emit('updateTeamCount', this.form.selected_users.length)
            this.$emit('close')
            this.$bvModal.hide('add-user-modal')
          }).catch(err => {
            this.showErrorMessage(err)
          }).finally(() => { this.isProcessing = false })
        } else {
          this.isProcessing = false
        }
      })
    },
    // handleUpdate(formData) {
    // },
  },

}
</script>
